import { defineComponent as _defineComponent } from 'vue'
import BroughTogetherTile from '~/components/BroughtTogetherTile.vue';
import CourseContentDetail from '~/components/CourseContentDetail.vue';
import CourseIncludes from '~/components/CourseIncludes.vue';
import FeaturedReview from '~/components/FeaturedReview.vue';
import Instructor from '~/components/Instructor.vue';
import LearningObjectives from '~/components/LearningObjectives.vue';
import MoreCourseByJoseph from '~/components/MoreCourseByJoseph.vue';
import RelatedTopics from '~/components/RelatedTopics.vue';
import SideBar from '~/components/SideBar.vue';
import StudentsAlsoBought from '~/components/StudentsAlsoBought.vue';
import TopCompanies from '~/components/TopCompanies.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,CourseContentDetail, CourseIncludes, FeaturedReview, Instructor, LearningObjectives, MoreCourseByJoseph, RelatedTopics, SideBar, StudentsAlsoBought, TopCompanies }
}

})